module.exports = __webpack_public_path__ + "img/small-5.951cc235.jpg";